import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "closeable", "onClose"],
  _excluded2 = ["as", "children"];
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { LayoutBoxBreezeBorder } from '../Layout/LayoutBoxBreezeBorder';
import { LayoutHorizontal } from '../Layout/LayoutHorizontal';
import { LayoutSpaceVertical } from '../Layout/LayoutSpaceVertical';
import { Heading } from '../Typography';
import { useModal } from '../Modal/Modal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AlertBreeze = _ref => {
  let {
      children,
      closeable,
      onClose
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isModalOpen,
    handleModalToggle
  } = useModal(true);
  const handleOnClose = () => {
    handleModalToggle();
    onClose === null || onClose === void 0 || onClose();
  };
  if (!isModalOpen) {
    return null;
  }
  return /*#__PURE__*/_jsx(LayoutBoxBreezeBorder, Object.assign({}, rest, {
    background: "background-color-light",
    borderRadius: "unset",
    paddingBlock: "space-xs",
    paddingInline: "space",
    children: /*#__PURE__*/_jsxs(LayoutHorizontal, {
      paddingInline: "space-xxs",
      children: [/*#__PURE__*/_jsx(LayoutSpaceVertical, {
        flex: 1,
        gap: "space-3xs",
        children: children
      }), closeable && /*#__PURE__*/_jsx(DialogCloseButton, {
        color: "icon-core-subtle",
        detached: true,
        onClick: handleOnClose,
        position: "static",
        size: "medium"
      })]
    })
  }));
};
const AlertBreezeTitle = _ref2 => {
  let {
      as = 'h6',
      children
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(Heading, Object.assign({
    as: as
  }, rest, {
    children: children
  }));
};
AlertBreeze.Title = AlertBreezeTitle;